import { useForm as useHookForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import { useTranslation } from 'react-i18next';

import { isValidPassword } from 'src/utils/helper';
import { REGEX } from 'src/constants/app';

export type FormValue = {
  new_password: string;
  re_password: string;
};

const useForm = () => {
  const { t } = useTranslation();
  const schema = Yup.object().shape({
    new_password: Yup.string()
      .required(t('message.E000003', { 0: t('auth_form.new_password_label') }))
      .matches(
        REGEX.REGEX_PASSWORD_MATCHES,
        t('message.E000042', { 0: t('auth_form.new_password_label') }),
      )
      .test(
        'valid-password',
        t('message.E000043', { 0: t('auth_form.new_password_label') }),
        isValidPassword,
      ),
    re_password: Yup.string()
      .required(
        t('message.E000003', { 0: t('auth_form.confirm_new_password_label') }),
      )
      .oneOf([Yup.ref('new_password')], t('message.E000044')),
  });

  const formInfo = useHookForm<FormValue>({
    resolver: yupResolver(schema),
    shouldFocusError: true,
    mode: 'onChange',
  });
  return { ...formInfo };
};

export default useForm;
